import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RecruitmentStepInitDTO } from './models';

@Injectable({
  providedIn: 'root'
})
export class RecruitmentStepsService {

  constructor(@Inject('API_URL') private _apiUrl: string, private _http: HttpClient) { }

  public getRecruitmentStepEditorData(): Observable<RecruitmentStepInitDTO> {
    let url: string = `${this._apiUrl}/admin/recruitment-steps/editor`;

    return this._http.get<RecruitmentStepInitDTO>(url);
  }

  public saveRecruitmentSteps(recruitmentSteps: RecruitmentStepGroupViewModel[]): Observable<SavedRecruitmentStepDTO[]> {
    let url: string = `${this._apiUrl}/admin/recruitment-steps`;

    return this._http.post<SavedRecruitmentStepDTO[]>(url, recruitmentSteps);
  }

  public getListOfRecruitmentSteps(): Observable<RecruitmentStepListItemDTO[]> {
    let url: string = `${this._apiUrl}/admin/recruitment-steps/list`;

    return this._http.get<RecruitmentStepListItemDTO[]>(url);
  }

  // get all email template ids available in the system (used when trying to change application status manually: display all available email templates)
  public getAllowedEmailTemplatesIds(applicationId: number, selectionStepId: number,stepAction: StepAction): Observable<number[]> {
    let url: string = `${this._apiUrl}/admin/recruitment-steps/allowed-email-templates?applicationId=${applicationId}&selectionStepId=${selectionStepId}&stepAction=${stepAction}`;

    return this._http.get<number[]>(url);
  }

  // TODO: get email templates related to a specific Email Template Type
  // get Collect Feedback Request email template ids
  public collectFeedbackRequestEmailTemplateIds(): Observable<number[]> {
    let url: string = `${this._apiUrl}/admin/recruitment-steps/collect-feedback-templates`;

    return this._http.get<number[]>(url);
  }

  // get allowed email template ids set in settings > selection steps > email templates
  public getAllEmailTemplatesIds(): Observable<number[]> {
    let url: string = `${this._apiUrl}/admin/email-templates/email-template-ids`;

    return this._http.get<number[]>(url);
  }

  // get email template ids as per type
  public getEmailTemplatesByTypeIds(templateTypeIds: number[] | null): Observable<number[]> {
    let url: string = `${this._apiUrl}/admin/email-templates/by-types`;

    return this._http.post<number[]>(url, templateTypeIds);
  }

  public assignStepId(recruitmentSteps: RecruitmentStepGroupViewModel[], steps: RecruitmentStepListItemDTO[]) {
    recruitmentSteps.forEach(viewModel => {
      let relatedSavedStep = steps.find(s => s.order === viewModel.order)!;

      viewModel.recruitmentStepId = relatedSavedStep.recruitmentStepId;
    });
  }

  // TODO: use common
  public orderItems(items: IOrderable[]): IOrderable[] {
    let order: number = 1;
    items.forEach(i => {
      i.order = order;
      order++;
    });

    return items;
  }

  // TODO: use common
  public assignId(field: IFormIdentifiable) {
    field.controlId = Guid.newGuid();
  }
}
/** data needed to create or update Selection Steps */
export interface SaveRecruitmentStepCDTO {
  recruitmentStepId: number;
  name: string;
  order: number;
  description?: string;
  onStartEmailTemplateId?: number;
  feedbackFormTemplateIds: number[];
  prerequisiteStepIds?: number[];
}

export interface SavedRecruitmentStepDTO {
  selectionStepId: number;
  name: string;
}

/** List Selection steps Data in the grid */
export interface RecruitmentStepListItemDTO {
  name: string;
  recruitmentStepId: number;
  order: number;
  feedbackFormTemplateIds: number[] | null;
  onStartEmailTemplateIds: number[] | null;
  stepTypeId: number | null;
  description: string | null;
  showForEntityIds: number[] | null;
  prerequisiteStepIds: number[];
  showEmailCC: boolean;
  isOnline: boolean;
  alwaysEnabledApplicationStatusIds: number[];
}

export interface IOrderable {
  order: number;
}

export interface IFormIdentifiable {
  /** for ui usage only*/
  controlId: string;
}
// TODO: move to common
export class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export interface RecruitmentStepGroupViewModel extends IOrderable, IFormIdentifiable {
  recruitmentStepId: number | null;
  name: string;
  description: string;
  order: number;
  onStartEmailTemplateIds: number[] | null;
  feedbackFormTemplateIds: number[] | null;
  stepTypeId: number | null;
  showForEntityIds: number[] | null;
  prerequisiteStepIds: number[];
  showEmailCC: boolean;
  isOnline: boolean;
  alwaysEnabledApplicationStatusIds: number[];
}

export enum StepAction
{
    Start,
    Reschedule,
    Cancel,
    Reject,
    Feedback
}
